/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Purchase offer and the current viewer’s desired dashboard visibility. */
export type BuyerPurchaseOfferSetHiddenInput = {
  /** True moves this viewer’s purchase to Other; false restores its normal tab. */
  isHidden: Types.Scalars['Boolean']['input'];
  /** Visible purchase offer to hide or unhide. */
  offerId: Types.Scalars['UUID']['input'];
};

export type BuyerPurchaseOfferSetHiddenMutationVariables = Exact<{
  input: Types.BuyerPurchaseOfferSetHiddenInput;
}>;


export type BuyerPurchaseOfferSetHiddenMutation = { buyerPurchaseOfferSetHidden:
    | { __typename: 'InvalidInputError', message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', message: Types.Scalars['String']['output'] }
    | { __typename: 'PurchaseOfferDashboardState', id: Types.Scalars['ID']['output'], isHidden: Types.Scalars['Boolean']['output'] }
    | { __typename: 'UnauthorizedError', message: Types.Scalars['String']['output'] }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const BuyerPurchaseOfferSetHiddenDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BuyerPurchaseOfferSetHidden($input: BuyerPurchaseOfferSetHiddenInput!) {
  buyerPurchaseOfferSetHidden(input: $input) {
    __typename
    ... on PurchaseOfferDashboardState {
      id
      isHidden
    }
    ... on Error {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BuyerPurchaseOfferSetHiddenMutation, BuyerPurchaseOfferSetHiddenMutationVariables>;